module.exports = {
	"header": "Spotin partners with SelmaStories",
	"date": "2023/02/21",
	"imgSrc": "selma_stories.jpg",
	"imgAlt": "Spotin partners with SelmaStories",
	"ingress": "The book site SelmaStories has launched Spotin’s content commerce solution on their site to offer their visitors shopping of books.",
	"sections": [
		{
			"paragraphs": [
				"On SelmaStories, Swedish book lovers can find book tips, interviews with authors, and reportage. Now, SelmaStories wants to take their user experience to the next level by giving their visitors the opportunity to shop for books on their site. With Spotin’s content commerce solution, SelmaStories can offer multiple shopping experiences. Visitors are able to get in-depth information and shop for books directly in articles. SelmaStories has also launched a Spotin-enabled e-shop, where visitors can be inspired and find books from all types of genres. The purchase checkout happens directly on the site, which offers a friction-free experience.",
				"SelmaStories is able to offer a consistent brand experience in the shopping features enabled by Spotin’s customized branding solution."
			]
		},
		{
			"paragraphs": [
				"<br><strong>See Spotin’s service live on SelmaStories:</strong>",
				"<a href='https://www.selmastories.se/artikel/handelser-vid-vatten/' style='text-decoration: underline;'>Example of shoppable editorial content on SelmaStories</a>",
				"<a href='https://www.selmastories.se/#/sp?s=1' style='text-decoration: underline;'>SelmaStories' shop</a>"
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./pages/news/14/article.json
// module id = 12
// module chunks = 0